import "../stylesheets/public.css";
import { isSupported, apply } from "invokers-polyfill/fn";
import "@hotwired/turbo";
import { initializeDialogs } from "../lib/dialog";
import {
  BannerElement,
  CandidaciesFilterElement,
  CollapsibleSectionElement,
  ComboBoxElement,
  ConditionalInputsElement,
  ClipboardCopyElement,
  DropdownMenuElement,
  FilterOptionsElement,
  ImageInputElement,
  NavigatorShareElement,
  NestedFieldsElement,
  PayrexxIframeElement,
  RangeSliderElement,
  ScrollingLoaderElement,
  ScrollTopButtonElement,
  SmartMapElement,
  ToastElement,
  VideoPlayerElement,
} from "../elements";
import {
  CharacterCounterElement,
  ClickableCardElement,
  FormAutosubmitElement,
} from "sprinkles-js";

if (!isSupported()) apply();

BannerElement.register();
CandidaciesFilterElement.register();
CharacterCounterElement.register();
ClickableCardElement.register();
CollapsibleSectionElement.register();
ComboBoxElement.register();
ConditionalInputsElement.register();
ClipboardCopyElement.register();
DropdownMenuElement.register();
FilterOptionsElement.register();
FormAutosubmitElement.register();
ImageInputElement.register();
NavigatorShareElement.register();
NestedFieldsElement.register();
PayrexxIframeElement.register();
RangeSliderElement.register();
ScrollingLoaderElement.register();
ScrollTopButtonElement.register();
SmartMapElement.register();
ToastElement.register();
VideoPlayerElement.register();
// Initialize dialog functionality
initializeDialogs();

document.addEventListener(
  "command",
  (e) => {
    if (e.command === "--close-details") closeDetails(e);
  },
  { capture: true },
);

function closeDetails(e) {
  const dialog = e.target;
  if (!dialog) return;
  dialog.removeAttribute("open");
}
